export function formatRelativeTime(isoString, now = Date.now()) {
  if (!isoString) return ""

  const then = new Date(isoString).getTime()
  if (Number.isNaN(then)) return ""

  const diffSec = Math.round((then - now) / 1000)
  const rtf = new Intl.RelativeTimeFormat(undefined, { numeric: "auto" })

  const absSec = Math.abs(diffSec)
  if (absSec < 60) return rtf.format(diffSec, "second")

  const diffMin = Math.round(diffSec / 60)
  if (Math.abs(diffMin) < 60) return rtf.format(diffMin, "minute")

  const diffHour = Math.round(diffSec / 3600)
  if (Math.abs(diffHour) < 24) return rtf.format(diffHour, "hour")

  const diffDay = Math.round(diffSec / 86400)
  return rtf.format(diffDay, "day")
}
